import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/app/globals-dark-fix.css");
;
import(/* webpackMode: "eager" */ "/app/app/globals-performance.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/auth/SessionActivityTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/auth/TokenRefreshManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/auth/TokenSynchronizer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/layout/ConditionalHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/wrappers/OfflineModeClientWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TenantProvider"] */ "/app/contexts/TenantContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/contexts/ThemeContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Orbitron\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-orbitron\"}],\"variableName\":\"orbitron\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Rajdhani\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--font-rajdhani\"}],\"variableName\":\"rajdhani\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/sonner/dist/index.mjs");
